import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { IWorkbookInfo } from '../models/IWorkbookInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { Workbooks } from '../resources/Workbooks';
import { IResult } from '../ServerApi/types/IResponse';
import { ActionHelpers } from './ActionHelpers';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { WorkbookErrors } from './WorkbookErrors';

export class DeleteWorkbooksAction {

  public static $inject = ['WorkbookErrors', 'ActionHelpers', 'ConfirmActionDialog', '$translate', 'Workbooks'];

  constructor(
    private WorkbookErrors: WorkbookErrors,
    private ActionHelpers: ActionHelpers,
    private ConfirmActionDialog: ConfirmActionDialog,
    private $translate: ng.translate.ITranslateService,
    private Workbooks: Workbooks) { }

  public confirmDeleteWorkbooks(workbooks: Set<IWorkbookInfo>, context: IActionContext): ng.IPromise<IResult> {

    const viewCount = workbooks.sum((w: IWorkbookInfo) => w.numSheets);

    const dialogBody = workbooks.size() === 1
      ? this.$translate.instant('confirmDeleteWorkbook', {
          WORKBOOK_NAME: L10n.elideIfLong(workbooks.first().name),
          VIEW_COUNT: viewCount
        }, L10n.Interpolations.Count)
      : this.$translate.instant('confirmDeleteWorkbooks', {
          WORKBOOK_COUNT: workbooks.size(),
          VIEW_COUNT: viewCount
        }, L10n.Interpolations.Count);

    return this.ConfirmActionDialog.open({
      scope: context.scope,
      title: this.$translate.instant('deleteMessage'),
      bodyText: dialogBody,
      actionName: this.$translate.instant('confirmDeleteButton', {
        ITEM_COUNT: workbooks.size()
      }, L10n.Interpolations.Count),
      isDeleteAction: true,

      action: (dialogInstance: IConfirmActionDialogInstance) => {
        return this.Workbooks.del(workbooks.keys()).then(
          (result: IResult) => this.notifyResult(workbooks, result));
      }
    }).result;
  }

  private notifyResult(workbooks: Set<IWorkbookInfo>, result: IResult) {
    this.ActionHelpers.notifyStandardError(
      workbooks,
      {
        successId: 'deleteWorkbooksSuccess',
        errorId: 'deleteWorkbooksError'
      },
      (errorItem: IErrorItem<IWorkbookInfo>) => this.WorkbookErrors.errorDetailsFor(errorItem))(result);
  }

}

Module.instance().service('DeleteWorkbooksAction', DeleteWorkbooksAction);
